import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { OrgBillingPage } from "../iam/organization/components/OrgBillingPage";

/**
 * billingSearchSchema reads the two parameters Stripe appends when a payment method that
 * confirms by redirect (Revolut Pay, for one) returns the reader here: the SetupIntent it
 * confirmed, and how the redirect ended. The page finishes that card setup and clears them.
 * Stripe's third parameter, the intent's client secret, is not read: the attach names the
 * intent by id and the server checks it belongs to the organization.
 */
const billingSearchSchema = z.object({
  redirect_status: z.string().optional(),
  setup_intent: z.string().optional(),
});

/**
 * Route is /organizations/$organizationId/billing: the organization's Billing page. A
 * self-serve organization's Data API subscription, payment methods, billing address and
 * invoices, its first card collected with the promotion code it is given; an organization
 * billed by agreement, or awaiting one, the products and published itineraries its agreement
 * grants, which staff edit in place and everybody else reads with the lock. Open to every role
 * and to staff: the page gates its mutating controls on who may manage billing. A card is
 * collected inline, and the page is where a card a redirect interrupted comes back to.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/billing")({
  component: OrgBillingPage,
  validateSearch: billingSearchSchema,
});
